export default __webpack_public_path__ + "static/media/intro.f7fc6b61.png";